import { logSearchError } from '../util/clientLogger'
import { fireGtm } from '../util/flyGaLogic'

const clientErrorRedirect = (errorMessage) => {
  const urlParams = new URLSearchParams(window.location.search)

  const cartKey = urlParams.get('cart-key')
  if (cartKey) {
    logSearchError('Package Search Cart Error', errorMessage)

    window.location.assign('/shop/search')
    return
  }

  const offerToken = urlParams.get('offer-token')
  const uspCacheKey = urlParams.get('usp-cache-key')
  const userActionType = urlParams.get('userActionType')
  const params = {
    'num-adults': urlParams.get('num-adults') || 1,
    'num-children': urlParams.get('num-children') || 0,
    'num-infants': urlParams.get('num-infants') || 0,
  }

  if (uspCacheKey) {
    params['usp-cache-key'] = uspCacheKey
  }
  if (offerToken) {
    params['offer-token'] = offerToken
  }
  if (userActionType) {
    params['userActionType'] = userActionType
  }

  const redirectParams = new URLSearchParams(params).toString()

  const url = `/m/fly/search/noresults?${redirectParams}`

  fireGtm('send', 'event', 'MFLY-Listings', `Error Redirect: ${url}`, errorMessage)

  window.location.assign(url)
}

export { clientErrorRedirect }
